/* NOTE: This file is a copy of react-file-reader from npm -
 * copied here (and converted to TypeScript) due to a bug with
 * a dependency on the uuid4 package at the time of writing */

/* eslint-disable react/sort-comp */

import * as React from "react";
import * as PropTypes from "prop-types";

interface IBase64FileList {
  fileList: FileList;
  base64: string | ArrayBuffer | null;
}

interface IBase64ArrayFileList {
  fileList: FileList;
  base64: any[] | null;
}

interface IProps {
  handleFiles: (
    fileList: FileList | IBase64FileList | IBase64ArrayFileList | null
  ) => void;
  fileTypes: string;
  multipleFiles: boolean;
  base64: boolean;
  disabled: boolean;
  elementId: string;
}

export default class ReactFileReader extends React.Component<IProps> {
  public static defaultProps = {
    fileTypes: "image/*",
    multipleFiles: false,
    base64: false,
    disabled: false,
    elementId: undefined,
  };

  public static propTypes = {
    multipleFiles: PropTypes.bool,
    handleFiles: PropTypes.func.isRequired,
    fileTypes: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    base64: PropTypes.bool,
    children: PropTypes.element.isRequired,
    disabled: PropTypes.bool,
    elementId: PropTypes.string,
  };

  private fileInput: HTMLInputElement;

  public render() {
    const hideInput: React.CSSProperties = {
      width: "0px",
      opacity: 0,
      position: "fixed",
    };

    const {
      children,
      disabled,
      elementId,
      fileTypes,
      multipleFiles,
    } = this.props;

    const optionalAttributes: { id?: string } = {};
    if (elementId) {
      optionalAttributes.id = elementId;
    }

    return (
      <div className="react-file-reader">
        <input
          type="file"
          onChange={this.handleFiles}
          accept={Array.isArray(fileTypes) ? fileTypes.join(",") : fileTypes}
          className="react-file-reader-input"
          ref={this.setFileInput}
          multiple={multipleFiles}
          style={hideInput}
          disabled={disabled}
          {...optionalAttributes}
        />

        <div className="react-file-reader-button" onClick={this.clickInput}>
          {children}
        </div>
      </div>
    );
  }

  private setFileInput = (element: HTMLInputElement) => {
    this.fileInput = element;
  };

  private clickInput = () => {
    const element = this.fileInput;
    element.value = "";
    element.click();
  };

  private handleFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { handleFiles, base64 } = this.props;

    const targetInput = event.target as HTMLInputElement;

    if (base64) {
      if (targetInput.files) {
        this.convertFilesToBase64(targetInput.files);
      } else {
        throw new Error("Invalid state - targetInput.files is null");
      }
    } else {
      handleFiles(targetInput.files);
    }
  };

  private convertFilesToBase64 = (fileList: FileList) => {
    const { handleFiles, multipleFiles } = this.props;

    if (multipleFiles) {
      const files: IBase64ArrayFileList = { base64: [], fileList };

      for (let i = 0, len = fileList.length; i < len; i += 1) {
        const reader = new FileReader();
        const f = fileList[i];

        reader.onloadend = () => {
          if (!reader.result) {
            throw new Error("Invalid state - reader.result is null");
          }

          if (!files.base64) {
            throw new Error("Invalid state - files.base64 is null");
          }

          files.base64.push(reader.result);

          if (files.base64.length === fileList.length) {
            handleFiles(files);
          }
        };

        reader.readAsDataURL(f);
      }
    } else {
      const files: IBase64FileList = { base64: "", fileList };
      const f = fileList[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        files.base64 = reader.result;
        handleFiles(files);
      };

      reader.readAsDataURL(f);
    }
  };
}



// WEBPACK FOOTER //
// ./src/scripts/components/ReactFileReader.tsx